'use client';

import { useEffect, useState } from 'react';
import {
  isOverwolfAvailable,
  getOverwolfVersion,
} from '../services/overwolf/overwolf-api.service';

interface UseOverwolfApiHook {
  isAvailable: boolean;
  version: string | null;
}

// -----------------------------------------------------------------------------
/**
 * Detects whether the page is running inside the Overwolf client by checking
 * for the global `overwolf` object on `window`. When present, it lazily loads
 * the Overwolf API service (responsible for communicating with the Overwolf
 * APIs) and exposes the client version.
 */
export const useOverwolfApi = (): UseOverwolfApiHook => {
  const [isAvailable, setIsAvailable] = useState(false);
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    // isOverwolfAvailable() is false off-client (and on the server), so this is
    // a no-op outside the Overwolf client.
    if (!isOverwolfAvailable()) {
      return;
    }

    setIsAvailable(true);
    setVersion(getOverwolfVersion());
  }, []);

  return { isAvailable, version };
};

export default useOverwolfApi;
